import { QueryClient } from '@tanstack/react-query';
import { isApiError, type ApiErrorKind } from '@/lib/api-errors';

const NO_RETRY_KINDS: ApiErrorKind[] = [
  'unauthorized',
  'forbidden',
  'not-found',
  'validation',
  'rate-limited',
];

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isApiError(error) && NO_RETRY_KINDS.includes(error.kind)) {
            return false;
          }
          return failureCount < 3;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}

export const queryClient = createQueryClient();
